import userServices from '@/services/user';

const state = {
  userRecord: {},
};

const getters = {
  getIsDone: (state) => (type) => {
    const apiResult = state.userRecord[type];
    const isDone = apiResult?.isDone || false;
    return isDone === true;
  },
  getRecordData: (state) => (type) => {
    const apiResult = state.userRecord[type];
    const data = apiResult?.data;
    return data || {};
  },
};

const actions = {
  async getUserRecordIsDone({commit}, type) {
    let isForce = false;
    if (typeof type === 'object') {
      isForce = type.isForce;
      type = type.type;
    }
    const result = await userServices.getUserRecord(type, isForce);
    const isDone = result?.isDone || false;
    commit('setUserRecord', {[type]: result});
    return isDone;
  },
  async getUserRecordData({state, commit}, type) {
    let result = state.userRecord[type];
    if (result?.isDone) return result;
    const isForce = true;
    result = await userServices.getUserRecord(type, isForce);
    commit('setUserRecord', {[type]: result});
    return result;
  },
};

const mutations = {
  setUserRecord(state, value) {
    state.userRecord = {...state.userRecord, ...value};
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
